import { useAuthSession } from './useAuthSession';
import { useDocumentTitle } from './useDocumentTitle';
import { useJiraSyncHealthLoading } from './useJiraSyncHealthLoading';
import { useMaintenanceLabelHoursAutoload } from './useMaintenanceLabelHoursAutoload';
import { useManagerOnlyGuard } from './useManagerOnlyGuard';
import { useUrlToView } from './useUrlToView';
import { useViewDataLoading } from './useViewDataLoading';

/* Effets globaux de l'application : synchronisation URL ↔ vue, garde des vues réservées aux
   managers, titre de l'onglet, session, et chargement des données de la vue affichée. */
export function useAppEffects({ store, api, loadProfile, location, navigate, update }) {
  const { appState, profile, session, viewAsMemberId, appDataLoaded } = store;
  useUrlToView({ location, navigate, appState, update });
  useManagerOnlyGuard({ navigate, profile, appState, viewAsMemberId });
  useDocumentTitle({ appState });
  useAuthSession({
    loadProfile,
    setAuthLoading: store.setAuthLoading,
    setIsRecovery: store.setIsRecovery,
    setProfile: store.setProfile,
    setRecoveryType: store.setRecoveryType,
    setSession: store.setSession,
  });
  useViewDataLoading({
    adminUsers: store.adminUsers,
    appDataLoaded,
    handleOpenJiraAuthors: api.handleOpenJiraAuthors,
    loadAbsences: api.loadAbsences,
    loadAdminUsers: api.loadAdminUsers,
    loadDealViews: api.loadDealViews,
    loadDeals: api.loadDeals,
    loadTenders: api.loadTenders,
    loadContacts: api.loadContacts,
    loadJiraData: api.loadJiraData,
    loadJiraImportLogs: api.loadJiraImportLogs,
    loadHoursByBrick: api.loadHoursByBrick,
    loadLateHours: api.loadLateHours,
    loadLeaveMovements: api.loadLeaveMovements,
    loadTimesheetMonth: api.loadTimesheetMonth,
    loadUserAbsences: api.loadUserAbsences,
    profile,
    session,
    appState,
    timesheetUserId: store.timesheetUserId,
    timesheetMonth: store.timesheetMonth,
  });
  useJiraSyncHealthLoading({ loadJiraSyncHealth: api.loadJiraSyncHealth, profile, session });
  useMaintenanceLabelHoursAutoload({
    appDataLoaded,
    loadLabelHours: api.loadLabelHours,
    maintenanceLabelHours: store.maintenanceLabelHours,
    profile,
    selectedClient: store.selectedClient,
    session,
    appState,
  });
}
